<script setup lang="ts">
import { PropType, computed } from 'vue';
import Textarea from 'primevue/textarea';
import AppFormInputBase from './app-form-input-base.vue';
import inputeTextPreset from '@/presets/customizations/inputtext';

const modelValue = defineModel<string | null>();
const props = defineProps({
  label: {
    type: String,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
  },
  icon: {
    type: String,
  },
  width: {
    type: Number,
  },
  errors: {
    type: Object as PropType<{ _errors: string[] }>,
  },
  rows: {
    type: Number,
    default: 5,
  },
  maxLength: {
    type: Number,
  },
});

const style = computed(() => {
  return {
    width: props.width ? props.width + 'px' : 'unset',
  };
});

const remainingCharacters = computed(() => {
  if (!props.maxLength) return 0;
  return props.maxLength - (modelValue.value?.length || 0);
});
</script>

<template>
  <app-form-input-base :label="props.label" :errors="props.errors" :maxLength="props.maxLength">
    <template #default="{ id }">
      <div class="flex flex-col w-full">
        <div class="w-full">
          <i
            :class="props.icon"
            class="absolute flex-none top-2/4 -mt-2 left-3 text-surface-400 dark:text-surface-600"
            v-if="!!props.icon"
          />
          <Textarea
            :id="id"
            :class="{ 'pl-10': !!props.icon }"
            class="!w-full !py-2 text-[15px]"
            v-model="modelValue"
            :placeholder="props.placeholder ? $t(props.placeholder) : undefined"
            :style="style"
            :readonly="props.readonly"
            :disabled="props.disabled"
            :invalid="!!props.errors?._errors?.length"
            :rows="props.rows"
            :maxlength="props.maxLength || 1000"
            :ptOptions="{ mergeSections: true, mergeProps: true }"
            :pt="inputeTextPreset"
          />
        </div>
        <div class="text-gray-600 dark:text-gray-400 text-[12px]" v-if="props.maxLength">
          {{ $t('core.remainingCharacters', { count: remainingCharacters }) }}
        </div>
      </div>
    </template>
  </app-form-input-base>
</template>
